export default class OptionData {

    /**
     * 
     * @param {String} dialogId 
     * @param {String} situationId 
     * @param {String} optionId 
     * @param {String} skill 
     * @param {String} behaviour 
     * @param {Boolean} isCorrect
     * @param {Number} timeToAnswer - in msecs 
     */
    constructor(dialogId, situationId, optionId, skill, behaviour, isCorrect, timeToAnswer) {
        this.dialogId = dialogId;
        this.situationId = situationId;
        this.optionId = optionId;
        this.skill = skill;
        this.behaviour = behaviour;
        this.isCorrect = isCorrect;
        this.timeToAnswer = timeToAnswer;
    }
}
